/* FC Casket Builder — regional recolor engine (lid / body / hardware / head panel).
   Canvas-composited: immune to theme CSS. Selections attach to the main
   Add-to-cart form as line item properties. */
(function () {
  'use strict';

  function hexHsl(hex) {
    var h = hex.replace('#', ''), r = parseInt(h.substr(0, 2), 16) / 255,
        g = parseInt(h.substr(2, 2), 16) / 255, b = parseInt(h.substr(4, 2), 16) / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, s = 0, hu = 0, d = mx - mn;
    if (d > 0) {
      s = d / (1 - Math.abs(2 * l - 1));
      if (mx === r) hu = 60 * (((g - b) / d) % 6);
      else if (mx === g) hu = 60 * ((b - r) / d + 2);
      else hu = 60 * ((r - g) / d + 4);
      if (hu < 0) hu += 360;
    }
    return [hu, s * 100, l * 100];
  }
  function hslHex(h, s, l) {
    s /= 100; l /= 100;
    var c = (1 - Math.abs(2 * l - 1)) * s, x = c * (1 - Math.abs((h / 60) % 2 - 1)), m = l - c / 2, r = 0, g = 0, b = 0;
    if (h < 60) { r = c; g = x; } else if (h < 120) { r = x; g = c; } else if (h < 180) { g = c; b = x; }
    else if (h < 240) { g = x; b = c; } else if (h < 300) { r = x; b = c; } else { r = c; b = x; }
    return '#' + [r, g, b].map(function (v) { return ('0' + Math.round((v + m) * 255).toString(16)).slice(-2); }).join('').toUpperCase();
  }

  function targetCartForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].classList.contains('fc-ajax-add')) continue;
      if (forms[i].querySelector('[name="id"]')) return forms[i];
    }
    return null;
  }
  function setProp(form, key, val) {
    var name = 'properties[' + key + ']';
    var el = form.querySelector('input[name="' + name.replace(/([\[\]])/g, '\\$1') + '"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden'; el.name = name; el.dataset.fcCb = '1';
      form.appendChild(el);
    }
    el.value = val;
  }

  function init(root) {
    if (root.dataset.fcCbReady) return;
    root.dataset.fcCbReady = '1';

    var cfg = {
      base: root.dataset.base, lid: root.dataset.lidMask,
      body: root.dataset.bodyMask, hw: root.dataset.hwMask,
      quad: (root.dataset.quad || '').split(',').map(Number),
      wireForm: root.dataset.wireForm === '1',
      autocycle: root.dataset.autocycle === '1',
      artScale: parseFloat(root.dataset.artScale || '100') / 100,
      artDx: parseFloat(root.dataset.artDx || '0') / 100,
      artDy: parseFloat(root.dataset.artDy || '0') / 100,
      artTilt: parseFloat(root.dataset.artTilt || '0') * Math.PI / 180
    };
    var QUAD = cfg.quad.length === 6
      ? { tl: [cfg.quad[0], cfg.quad[1]], tr: [cfg.quad[2], cfg.quad[3]], bl: [cfg.quad[4], cfg.quad[5]] }
      : { tl: [278, 352], tr: [552, 338], bl: [286, 472] };

    var state = {
      lid: { hex: root.dataset.lidDefault || '#F2EFE8', name: root.dataset.lidDefaultName || 'White' },
      body: { hex: root.dataset.bodyDefault || '#2E4A8F', name: root.dataset.bodyDefaultName || 'Midnight Blue' },
      hw: 'silver', art: '', artName: '', upload: null, uploadName: ''
    };
    var HW = { silver: null, bronze: '#8C6239', gold: '#C9A254' };

    var stageBox = root.querySelector('.fc-cb-stage');
    var imgs = {}, ready = 0, need = 0, cv, ctx, off, octx, spec, queued = false, interacted = false;

    function load(key, src) {
      if (!src) return;
      need++;
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { imgs[key] = im; if (++ready === need) start(); };
      im.onerror = function () { console.warn('FC Builder: failed to load', key, src); };
      im.src = src;
    }
    load('base', cfg.base); load('lid', cfg.lid); load('body', cfg.body); load('hw', cfg.hw);
    // preload only the featured tiles — gallery tiles (.fc-cb-lazy) load on demand
    root.querySelectorAll('.fc-cb-art[data-src]:not(.fc-cb-lazy)').forEach(function (el) {
      load('a_' + el.dataset.art, el.dataset.src);
    });

    function start() {
      if (!imgs.base) return;
      cv = document.createElement('canvas');
      cv.width = imgs.base.naturalWidth; cv.height = imgs.base.naturalHeight;
      cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:3;';
      stageBox.appendChild(cv);
      ctx = cv.getContext('2d');
      off = document.createElement('canvas'); off.width = cv.width; off.height = cv.height;
      octx = off.getContext('2d');
      spec = document.createElement('canvas'); spec.width = cv.width; spec.height = cv.height;
      var s = spec.getContext('2d');
      s.drawImage(imgs.base, 0, 0);
      s.globalCompositeOperation = 'multiply';
      s.drawImage(imgs.base, 0, 0); s.drawImage(imgs.base, 0, 0);
      // sanity-check masks: a mask without transparency floods the whole image with paint
      ['lid', 'body', 'hw'].forEach(function (k) {
        if (!imgs[k]) return;
        try {
          var t = document.createElement('canvas'); t.width = 64; t.height = 64;
          var tc = t.getContext('2d');
          tc.drawImage(imgs[k], 0, 0, 64, 64);
          var px = tc.getImageData(0, 0, 64, 64).data, clear = 0;
          for (var i = 3; i < px.length; i += 4) { if (px[i] < 250) clear++; }
          if (clear < px.length / 4 * 0.02) {
            console.warn('FC Builder: the ' + k + ' mask has no transparency — it would flood the whole image. Ignoring it.');
            delete imgs[k];
            if (window.Shopify && window.Shopify.designMode) {
              var note = document.createElement('div');
              note.style.cssText = 'margin:10px 0;padding:9px 12px;border:1px dashed #b2554f;color:#7d2420;background:#fff5f4;font-size:12px;line-height:1.5;';
              note.textContent = 'FC Casket Builder (editor-only): the ' + k + ' mask override is not a transparent mask PNG, so it was ignored. Clear that override to use the built-in Fairview mask, or upload the matching mask file.';
              root.appendChild(note);
            }
          }
        } catch (e) { /* cross-origin without CORS headers: skip the check */ }
      });
      draw();
      if (cfg.autocycle && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) cycle();
    }

    function recolorRegion(maskKey, hex) {
      if (!imgs[maskKey]) return;
      var W = cv.width, H = cv.height, L = hexHsl(hex)[2] / 100;
      var mul = Math.min(0.9, Math.max(0, (0.60 - L) * 1.75)),
          scr = Math.min(0.8, Math.max(0, (L - 0.72) * 2.4)),
          dark = Math.min(1, Math.max(0, (0.55 - L) * 2.2));
      octx.setTransform(1, 0, 0, 1, 0, 0);
      octx.globalCompositeOperation = 'source-over'; octx.globalAlpha = 1;
      octx.clearRect(0, 0, W, H);
      octx.drawImage(imgs.base, 0, 0, W, H);
      if (dark > 0.01) {
        octx.globalCompositeOperation = 'multiply'; octx.globalAlpha = dark;
        octx.drawImage(imgs.base, 0, 0, W, H);
        if (L < 0.3) { octx.globalAlpha = Math.min(1, (0.3 - L) * 3); octx.drawImage(imgs.base, 0, 0, W, H); }
        octx.globalAlpha = 1;
      }
      octx.globalCompositeOperation = 'color'; octx.fillStyle = hex; octx.fillRect(0, 0, W, H);
      if (mul > 0.005 || dark > 0.01) {
        octx.globalCompositeOperation = 'multiply';
        octx.globalAlpha = Math.min(0.97, mul + dark * 0.25); octx.fillRect(0, 0, W, H); octx.globalAlpha = 1;
      }
      if (scr > 0.005) {
        octx.globalCompositeOperation = 'screen'; octx.globalAlpha = scr; octx.fillRect(0, 0, W, H); octx.globalAlpha = 1;
      }
      // saturation restore — matte source photos mute the chroma; put it back
      octx.globalCompositeOperation = 'saturation';
      octx.globalAlpha = 0.55; octx.fillRect(0, 0, W, H); octx.globalAlpha = 1;
      // overlay depth — gloss-like contrast in the paint
      octx.globalCompositeOperation = 'overlay';
      octx.globalAlpha = 0.26; octx.fillRect(0, 0, W, H); octx.globalAlpha = 1;
      // speculars for every color — the metallic sheen
      octx.globalCompositeOperation = 'screen';
      octx.globalAlpha = Math.min(0.65, 0.2 + dark * 0.5);
      octx.drawImage(spec, 0, 0, W, H); octx.globalAlpha = 1;
      octx.globalCompositeOperation = 'destination-in'; octx.drawImage(imgs[maskKey], 0, 0, W, H);
      ctx.drawImage(off, 0, 0);
    }

    function tintHardware(hex) {
      if (!imgs.hw) return;
      var W = cv.width, H = cv.height;
      octx.setTransform(1, 0, 0, 1, 0, 0);
      octx.globalCompositeOperation = 'source-over'; octx.globalAlpha = 1;
      octx.clearRect(0, 0, W, H);
      octx.drawImage(imgs.base, 0, 0, W, H);
      octx.globalCompositeOperation = 'color'; octx.fillStyle = hex; octx.fillRect(0, 0, W, H);
      octx.globalCompositeOperation = 'multiply'; octx.globalAlpha = 0.34; octx.fillStyle = hex;
      octx.fillRect(0, 0, W, H); octx.globalAlpha = 1;
      octx.globalCompositeOperation = 'screen'; octx.globalAlpha = 0.32;
      octx.drawImage(spec, 0, 0, W, H); octx.globalAlpha = 1;
      octx.globalCompositeOperation = 'destination-in'; octx.drawImage(imgs.hw, 0, 0, W, H);
      ctx.drawImage(off, 0, 0);
    }

    function drawPanelArt(im) {
      var q = QUAD;
      var vx = [q.tr[0] - q.tl[0], q.tr[1] - q.tl[1]], vy = [q.bl[0] - q.tl[0], q.bl[1] - q.tl[1]];
      var wpx = Math.hypot(vx[0], vx[1]), hpx = Math.hypot(vy[0], vy[1]);
      var pad = 0.03, availW = 1 - 2 * pad, availH = 1 - 2 * pad;
      var ar = im.naturalWidth / im.naturalHeight, qr = wpx / hpx;
      var w, h;
      if (ar > qr) { w = availW; h = Math.min(availH, availW * qr / ar); }
      else { h = availH; w = Math.min(availW, availH * ar / qr); }
      w = Math.min(availW, w * 1.35);   // gentle widen so designs own the panel
      w = w * cfg.artScale; h = h * cfg.artScale;
      var ox = (1 - w) / 2 + cfg.artDx, oy = (1 - h) / 2 + 0.045 + cfg.artDy;
      ctx.save();
      ctx.setTransform(vx[0] * w / im.naturalWidth, vx[1] * w / im.naturalWidth,
                       vy[0] * h / im.naturalHeight, vy[1] * h / im.naturalHeight,
                       q.tl[0] + vx[0] * ox + vy[0] * oy, q.tl[1] + vx[1] * ox + vy[1] * oy);
      if (cfg.artTilt) {
        ctx.translate(im.naturalWidth / 2, im.naturalHeight / 2);
        ctx.rotate(cfg.artTilt);
        ctx.translate(-im.naturalWidth / 2, -im.naturalHeight / 2);
      }
      ctx.globalCompositeOperation = 'multiply';
      ctx.drawImage(im, 0, 0);
      ctx.restore();
      ctx.globalCompositeOperation = 'source-over';
    }

    function draw() {
      if (queued || !ctx) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.globalCompositeOperation = 'source-over';
        ctx.clearRect(0, 0, cv.width, cv.height);
        ctx.drawImage(imgs.base, 0, 0);
        recolorRegion('lid', state.lid.hex);
        recolorRegion('body', state.body.hex);
        if (HW[state.hw]) tintHardware(HW[state.hw]);
        if (state.upload) drawPanelArt(state.upload);
        else if (state.art && imgs['a_' + state.art]) drawPanelArt(imgs['a_' + state.art]);
        ui();
      });
    }

    function panelLabel() {
      return state.upload ? ('Custom photo — ' + state.uploadName) : (state.artName || 'Classic white');
    }

    function ui() {
      var set = function (sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; };
      set('.fc-cb-lbl-lid', state.lid.name + ' · ' + state.lid.hex);
      set('.fc-cb-lbl-body', state.body.name + ' · ' + state.body.hex);
      set('.fc-cb-lbl-hw', state.hw.charAt(0).toUpperCase() + state.hw.slice(1));
      set('.fc-cb-lbl-panel', panelLabel());
      var chips = root.querySelector('.fc-cb-chips');
      if (chips) {
        chips.innerHTML =
          '<span class="fc-cb-chip"><span class="fc-cb-dot" style="background:' + state.lid.hex + '"></span>Lid <b>' + state.lid.name + '</b></span>' +
          '<span class="fc-cb-chip"><span class="fc-cb-dot" style="background:' + state.body.hex + '"></span>Base <b>' + state.body.name + '</b></span>' +
          '<span class="fc-cb-chip">Hardware <b>' + state.hw.charAt(0).toUpperCase() + state.hw.slice(1) + '</b></span>' +
          '<span class="fc-cb-chip">Panel <b>' + panelLabel() + '</b></span>';
      }
      root.querySelectorAll('.fc-cb-sw').forEach(function (el) {
        el.classList.toggle('on', el.dataset.hex === state[el.dataset.zone].hex);
      });
      root.querySelectorAll('.fc-cb-hw').forEach(function (el) {
        el.classList.toggle('on', el.dataset.hw === state.hw);
      });
      root.querySelectorAll('.fc-cb-art').forEach(function (el) {
        el.classList.toggle('on', !state.upload && el.dataset.art === state.art);
      });
      var moreOn = !state.upload && state.art && state.art.indexOf('m-') === 0;
      root.querySelectorAll('.fc-cb-moresel').forEach(function (sel) {
        var v = moreOn ? state.art : '';
        if (sel.value !== v) sel.value = v;
      });
      var mp = root.querySelector('.fc-cb-moreprev');
      if (mp) {
        mp.hidden = !moreOn;
        if (moreOn) {
          var msel = root.querySelector('.fc-cb-moresel');
          var mo = (msel && msel.selectedIndex > -1) ? msel.options[msel.selectedIndex] : null;
          var mimg = mp.querySelector('img'), msp = mp.querySelector('span');
          if (mo && mimg && mimg.getAttribute('src') !== mo.getAttribute('data-src')) mimg.src = mo.getAttribute('data-src') || '';
          if (msp) msp.textContent = state.artName;
        }
      }
      var pr = root.querySelector('.fc-cb-props');
      if (pr) {
        pr.innerHTML = 'Lid color: <b>' + state.lid.name + ' (' + state.lid.hex + ')</b><br>' +
          'Base color: <b>' + state.body.name + ' (' + state.body.hex + ')</b><br>' +
          'Hardware: <b>' + state.hw.charAt(0).toUpperCase() + state.hw.slice(1) + '</b><br>' +
          'Head panel: <b>' + panelLabel() + '</b>';
      }
      if (cfg.wireForm) {
        var form = targetCartForm();
        if (form) {
          setProp(form, 'Lid color', state.lid.name + ' (' + state.lid.hex + ')');
          setProp(form, 'Base color', state.body.name + ' (' + state.body.hex + ')');
          setProp(form, 'Hardware', state.hw.charAt(0).toUpperCase() + state.hw.slice(1));
          setProp(form, 'Head panel', state.upload
            ? 'Custom photo (' + state.uploadName + ') — we will collect the file by phone/email'
            : (state.artName || 'Classic white'));
        }
      }
    }

    function markInteracted() { interacted = true; }
    root.addEventListener('pointerdown', markInteracted);

    // swatches
    root.querySelectorAll('.fc-cb-sw').forEach(function (b) {
      b.addEventListener('click', function () {
        state[b.dataset.zone] = { hex: b.dataset.hex, name: b.dataset.name };
        draw();
      });
    });
    // custom sliders
    root.querySelectorAll('.fc-cb-sliders').forEach(function (box) {
      box.querySelectorAll('input').forEach(function (sl) {
        sl.addEventListener('input', function () {
          var z = box.dataset.zone;
          var h = +box.querySelector('.fc-cb-hue').value, l = +box.querySelector('.fc-cb-lit').value;
          var s = Math.max(28, Math.round(58 - Math.max(0, (l - 70)) * 0.9 - Math.max(0, (25 - l)) * 0.8));
          var hex = hslHex(h, s, l);
          state[z] = { hex: hex, name: 'Custom' };
          draw();
        });
      });
    });
    root.querySelectorAll('.fc-cb-toggle').forEach(function (t) {
      t.addEventListener('click', function () {
        var box = root.querySelector('.fc-cb-sliders[data-zone=' + t.dataset.zone + ']');
        if (box) box.classList.toggle('open');
      });
    });
    // hardware
    root.querySelectorAll('.fc-cb-hw').forEach(function (b) {
      b.addEventListener('click', function () { state.hw = b.dataset.hw; draw(); });
    });
    // panel art (gallery tiles load their render image on first pick)
    root.querySelectorAll('.fc-cb-art').forEach(function (a) {
      a.addEventListener('click', function () {
        state.art = a.dataset.art || '';
        state.artName = a.dataset.name || '';
        state.upload = null; state.uploadName = '';
        var up = root.querySelector('.fc-cb-upload');
        if (up) up.value = '';
        var key = 'a_' + state.art;
        if (state.art && !imgs[key] && a.dataset.src) {
          var im = new Image();
          im.crossOrigin = 'anonymous';
          im.onload = function () { imgs[key] = im; draw(); };
          im.onerror = function () { console.warn('FC Builder: failed to load design', state.art); };
          im.src = a.dataset.src;
        }
        draw();
      });
    });

    // "Browse all designs" — reveal the gallery 20 tiles at a time
    var moreBtn = root.querySelector('.fc-cb-morebtn');
    var moreGrid = root.querySelector('.fc-cb-moregrid');
    if (moreBtn && moreGrid) {
      var BATCH = 20;
      var pendingTiles = function () { return moreGrid.querySelectorAll('.fc-cb-art[hidden]').length; };
      var setLabel = function () {
        var n = pendingTiles();
        if (!n) { moreBtn.hidden = true; return; }
        moreBtn.textContent = moreGrid.hidden
          ? (moreBtn.dataset.label || 'Browse all designs') + ' (' + n + ') \u25BE'
          : 'Show ' + Math.min(BATCH, n) + (Math.min(BATCH, n) === 1 ? ' more design' : ' more designs') + ' (' + n + ' remaining) \u25BE';
      };
      moreBtn.addEventListener('click', function () {
        moreGrid.hidden = false;
        var kids = moreGrid.children, shown = 0;
        for (var i = 0; i < kids.length && shown < BATCH; i++) {
          var el = kids[i];
          if (!el.hidden) continue;
          el.hidden = false;
          if (el.classList.contains('fc-cb-ghead')) continue;
          var tImg = el.querySelector('img[data-src]');
          if (tImg && !tImg.getAttribute('src')) tImg.src = tImg.getAttribute('data-src');
          shown++;
        }
        setLabel();
      });
      setLabel();
    }
    // zoom overlay — full-screen close-up of the current build
    var zbtn = root.querySelector('.fc-cb-zoom');
    if (zbtn) {
      zbtn.addEventListener('click', function () {
        if (!cv) return;
        var ov = document.createElement('div');
        ov.className = 'fc-cb-zoomov';
        ov.innerHTML =
          '<div class="fc-cb-zoombar">' +
            '<button type="button" class="fc-cb-zbtn" data-z="out" aria-label="Zoom out">&minus;</button>' +
            '<span class="fc-cb-zlvl">2&times;</span>' +
            '<button type="button" class="fc-cb-zbtn" data-z="in" aria-label="Zoom in">+</button>' +
            '<button type="button" class="fc-cb-zbtn fc-cb-zclose" aria-label="Close">&times;</button>' +
          '</div>' +
          '<div class="fc-cb-zoompane"><img alt="Casket close-up"></div>' +
          '<p class="fc-cb-zhint">Drag to look around &middot; use &minus; and + to zoom &middot; &times; to close</p>';
        document.body.appendChild(ov);
        var prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        var img = ov.querySelector('img'), pane = ov.querySelector('.fc-cb-zoompane');
        var levels = [1.25, 2, 3, 4.5], li = 1;
        function apply() {
          img.style.width = Math.round(pane.clientWidth * levels[li]) + 'px';
          ov.querySelector('.fc-cb-zlvl').textContent = levels[li] + '\u00D7';
        }
        function setLevel(n) {
          n = Math.max(0, Math.min(levels.length - 1, n));
          if (n === li) return;
          var cx = (pane.scrollLeft + pane.clientWidth / 2) / Math.max(1, img.offsetWidth);
          var cy = (pane.scrollTop + pane.clientHeight / 2) / Math.max(1, img.offsetHeight);
          li = n; apply();
          pane.scrollLeft = cx * img.offsetWidth - pane.clientWidth / 2;
          pane.scrollTop = cy * img.offsetHeight - pane.clientHeight / 2;
        }
        img.onload = function () {
          apply();
          pane.scrollLeft = (img.offsetWidth - pane.clientWidth) * 0.42;
          pane.scrollTop = (img.offsetHeight - pane.clientHeight) * 0.28;
        };
        img.src = cv.toDataURL('image/png');
        function close() {
          document.body.style.overflow = prevOverflow;
          document.removeEventListener('keydown', onKey);
          ov.remove();
        }
        function onKey(e) { if (e.key === 'Escape') close(); }
        document.addEventListener('keydown', onKey);
        ov.querySelector('.fc-cb-zclose').addEventListener('click', close);
        ov.querySelectorAll('[data-z]').forEach(function (b) {
          b.addEventListener('click', function () { setLevel(li + (b.dataset.z === 'in' ? 1 : -1)); });
        });
        img.addEventListener('dblclick', function () { setLevel(li >= 2 ? 1 : 3); });
        // mouse drag-to-pan (touch uses native scrolling)
        var drag = null;
        pane.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse') return;
          drag = { x: e.clientX, y: e.clientY, sl: pane.scrollLeft, st: pane.scrollTop };
          pane.style.cursor = 'grabbing'; e.preventDefault();
        });
        pane.addEventListener('pointermove', function (e) {
          if (!drag) return;
          pane.scrollLeft = drag.sl - (e.clientX - drag.x);
          pane.scrollTop = drag.st - (e.clientY - drag.y);
        });
        ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
          pane.addEventListener(ev, function () { drag = null; pane.style.cursor = 'grab'; });
        });
      });
    }

    // build snapshots — the shopper's exact casket, shown on their cart line (device-local)
    function buildSnapshot() {
      if (!cv) return null;
      try {
        var sc = document.createElement('canvas');
        var w = 480, h = Math.round(cv.height * (480 / cv.width));
        sc.width = w; sc.height = h;
        sc.getContext('2d').drawImage(cv, 0, 0, w, h);
        return sc.toDataURL('image/jpeg', 0.82);
      } catch (e) { return null; }
    }
    function newBuildId() {
      return 'FC' + Date.now().toString(36).toUpperCase() + Math.floor(Math.random() * 1296).toString(36).toUpperCase();
    }
    function saveBuild(id) {
      var data = buildSnapshot();
      if (!data) return false;
      try {
        localStorage.setItem('fcBuild:' + id, data);
        var keys = [];
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (k && k.indexOf('fcBuild:') === 0) keys.push(k);
        }
        keys.sort();
        while (keys.length > 12) localStorage.removeItem(keys.shift());
      } catch (e) { return false; }
      return true;
    }
    // main product form path: stamp a snapshot right as the form submits
    if (cfg.wireForm) {
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || !f.action || String(f.action).indexOf('/cart/add') === -1) return;
        if (f.classList && f.classList.contains('fc-ajax-add')) return;
        if (!cv) return;
        var bid = newBuildId();
        if (saveBuild(bid)) setProp(f, '_fcBuild', bid);
      }, true);
    }

    // section-level Add to cart (works on the standalone builder page and on product pages)
    var atc = root.querySelector('.fc-cb-atc');
    var atcErr = root.querySelector('.fc-cb-atcerr');
    function showAtcError(msg) {
      if (atcErr) { atcErr.hidden = false; atcErr.textContent = msg; }
    }
    if (atc) {
      atc.addEventListener('click', function () {
        var vid = atc.dataset.variantId;
        if (!vid || atc.disabled) return;
        if (atcErr) atcErr.hidden = true;
        var orig = atc.innerHTML;
        atc.disabled = true; atc.textContent = 'Adding\u2026';
        var fd = new FormData();
        fd.append('id', vid);
        fd.append('quantity', '1');
        fd.append('properties[Model]', root.dataset.model || 'Fairview');
        fd.append('properties[Lid color]', state.lid.name + ' (' + state.lid.hex + ')');
        fd.append('properties[Base color]', state.body.name + ' (' + state.body.hex + ')');
        fd.append('properties[Hardware]', state.hw.charAt(0).toUpperCase() + state.hw.slice(1));
        fd.append('properties[Head panel]', state.upload
          ? 'Custom photo (' + state.uploadName + ') \u2014 we will collect the file by phone/email'
          : (state.artName || 'Classic white'));
        var bid = newBuildId();
        if (saveBuild(bid)) fd.append('properties[_fcBuild]', bid);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.getSectionsToRender) {
          try {
            fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
            fd.append('sections_url', window.location.pathname);
          } catch (e) { /* drawer variant without the helper: plain add still works */ }
        }
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/add.js', {
          method: 'POST', body: fd,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) {
            return r.json()
              .catch(function () { return {}; })
              .then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
          })
          .then(function (res) {
            atc.disabled = false; atc.innerHTML = orig;
            if (!res.ok) {
              console.warn('FC Builder: /cart/add.js rejected', res.status, res.json);
              showAtcError((res.json && (res.json.description || res.json.message)) ||
                ('The cart did not accept this item (error ' + res.status + '). Please try again, or call us at +1 213-714-3400.'));
              return;
            }
            var d2 = document.querySelector('cart-drawer');
            if (d2 && d2.renderContents && res.json && res.json.sections) {
              try { d2.renderContents(res.json); return; } catch (e) { console.warn('FC Builder: drawer render failed, going to cart', e); }
            }
            window.location.href = rootUrl + 'cart';
          })
          .catch(function (e) {
            console.warn('FC Builder: add to cart failed', e);
            atc.disabled = false; atc.innerHTML = orig;
            showAtcError('We could not reach the cart just now. Please try again, or call us at +1 213-714-3400.');
          });
      });
    }

    // more-designs dropdown (images load on demand so the page stays fast)
    root.querySelectorAll('.fc-cb-moresel').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (!opt || !opt.value) return;
        state.art = opt.value;
        state.artName = (opt.textContent || '').trim();
        state.upload = null; state.uploadName = '';
        var upEl = root.querySelector('.fc-cb-upload');
        if (upEl) upEl.value = '';
        var key = 'a_' + opt.value;
        if (!imgs[key] && opt.getAttribute('data-src')) {
          var im = new Image();
          im.crossOrigin = 'anonymous';
          im.onload = function () { imgs[key] = im; draw(); };
          im.onerror = function () { console.warn('FC Builder: failed to load design', opt.value); };
          im.src = opt.getAttribute('data-src');
        }
        draw();
      });
    });
    // upload
    var up = root.querySelector('.fc-cb-upload');
    if (up) {
      up.addEventListener('change', function (e) {
        var f = e.target.files[0]; if (!f) return;
        var rd = new FileReader();
        rd.onload = function () {
          var im = new Image();
          im.onload = function () {
            state.upload = im; state.uploadName = f.name; state.art = ''; state.artName = '';
            draw();
          };
          im.src = rd.result;
        };
        rd.readAsDataURL(f);
      });
    }

    // autocycle (showcase): rotate tasteful presets until first interaction
    function cycle() {
      var presets = [
        { lid: ['#F2EFE8', 'White'], body: ['#2E4A8F', 'Midnight Blue'], hw: 'silver', art: 'sc1162', an: 'Red Rose' },
        { lid: ['#AEC6E8', 'Powder Blue'], body: ['#26272C', 'Classy Black'], hw: 'gold', art: 'sc1225', an: 'Dove of Light' },
        { lid: ['#F2EFE8', 'White'], body: ['#B3122E', 'Sport Red'], hw: 'gold', art: 'sc1137', an: 'American Flag' },
        { lid: ['#D8A0B4', 'Rose Pink'], body: ['#7C4A66', 'Plum'], hw: 'silver', art: 'sc1122', an: 'Twin Roses' },
        { lid: ['#F2EFE8', 'White'], body: ['#33523E', 'Forest Green'], hw: 'bronze', art: 'sc1151', an: 'Wheat Sheaf' }
      ];
      var i = 0;
      var t = setInterval(function () {
        if (interacted) { clearInterval(t); return; }
        var p = presets[i++ % presets.length];
        state.lid = { hex: p.lid[0], name: p.lid[1] };
        state.body = { hex: p.body[0], name: p.body[1] };
        state.hw = p.hw; state.art = p.art; state.artName = p.an;
        state.upload = null; state.uploadName = '';
        draw();
      }, 2200);
    }
  }

  function scan() { document.querySelectorAll('[data-fc-casket-builder]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
